var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-notice-detail',{staticClass:"pt-notice-detail__withData",attrs:{"id":_vm.id,"noticeDetail":_vm.noticeDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }